import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Wraps a rich in-chat card so a render error in one card never blanks the
 * entire conversation thread. Shows a small inline fallback instead.
 */
export class CardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[CardErrorBoundary] rich card failed to render', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="ai-card-error-boundary"
          className="mt-3 rounded-lg border border-rose-200 bg-rose-50 p-3 text-xs text-rose-700 inline-flex items-center gap-1.5 not-prose"
        >
          <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
          This card couldn't be displayed. The rest of the chat is unaffected.
        </div>
      );
    }
    return this.props.children;
  }
}

export default CardErrorBoundary;
